/* Maison Hydria — mention « paiement en 3 ou 4 fois sans frais » sous le prix,
   avec une infobulle au survol du « ? » qui donne les deux montants.

   Le prix est lu dans l'attribut data-value du thème (en centimes), pas dans le
   texte : c'est fiable quelle que soit la devise ou la mise en forme.

   Le montant suit la variante choisie (événements variant:updated / form:updated).
   Sous PAIEMENT_MINI, rien n'est affiché : PayPal et Klarna ne proposent pas le
   paiement fractionné sur les petits paniers.
*/
(function () {
  var PAIEMENT_MINI = 3000; // centimes — 30,00 €
  var CLASSE = 'mh-paiement';
  var HORS_CONTEXTE = 'sticky-add-to-cart, product-card, cart-drawer, quick-add-dialog, .mh-bonde, .mhba';

  function elementPrix() {
    var tous = document.querySelectorAll('product-price [data-ref="price"]');
    for (var i = 0; i < tous.length; i++) {
      if (!tous[i].closest(HORS_CONTEXTE)) return tous[i];
    }
    return null;
  }

  /* Le thème met à jour le TEXTE du prix lors d'un changement de variante mais laisse
     l'attribut data-value à sa valeur de rendu initial : on lit donc le texte en
     priorité, data-value ne sert que de secours. */
  function centimesDepuisTexte(txt) {
    if (!txt) return null;
    var t = txt.replace(/[\s\u00a0\u202f]/g, '').replace(/[^0-9.,]/g, '');
    if (!t) return null;
    if (t.indexOf(',') > -1) {
      t = t.replace(/\./g, '').replace(',', '.');
    } else if (!/\.\d{1,2}$/.test(t)) {
      t = t.replace(/\./g, '');
    }
    var v = parseFloat(t);
    if (isNaN(v)) return null;
    return Math.round(v * 100);
  }

  function prixCourant(el) {
    if (!el) return null;
    var p = centimesDepuisTexte(el.textContent);
    if (p) return p;
    var brut = parseInt(el.getAttribute('data-value'), 10);
    return isNaN(brut) || brut <= 0 ? null : brut;
  }

  function formate(centimes) {
    return (centimes / 100).toLocaleString('fr-FR', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    }) + ' €';
  }

  function styles() {
    if (document.getElementById('mh-paiement-style')) return;
    var s = document.createElement('style');
    s.id = 'mh-paiement-style';
    s.textContent = [
      '.mh-paiement{display:flex;align-items:center;gap:7px;margin-top:4px;',
      'font-size:15px;line-height:1.3;color:#1f1f1f}',
      '.mh-paiement__montant{color:#b08d57}',
      '.mh-paiement__aide{position:relative;display:inline-flex;align-items:center;justify-content:center;',
      'width:19px;height:19px;border-radius:50%;background:#b08d57;color:#fff;font-size:12px;line-height:1;',
      'cursor:help;border:0;padding:0;flex:0 0 19px;font-weight:600}',
      '.mh-paiement__bulle{position:absolute;bottom:calc(100% + 10px);left:50%;transform:translateX(-50%);',
      'width:290px;max-width:76vw;background:#fff;color:#1f1f1f;border:1px solid #e4ded4;border-radius:4px;',
      'padding:14px 16px;box-shadow:0 8px 28px rgba(0,0,0,.14);text-align:left;font-size:13px;line-height:1.5;',
      'font-weight:400;opacity:0;visibility:hidden;transition:opacity .15s;z-index:6;pointer-events:none}',
      '.mh-paiement__aide:hover .mh-paiement__bulle,',
      '.mh-paiement__aide:focus-visible .mh-paiement__bulle{opacity:1;visibility:visible}',
      '.mh-paiement__bulle b{display:block;margin-bottom:9px;font-size:14px}',
      '.mh-paiement__bulle span.l{display:block;margin-bottom:6px}',
      '.mh-paiement__bulle span.n{display:block;margin-top:9px;color:#6b6759;font-size:12px}',
      '.mh-paiement__fin{display:inline-flex;align-items:center;gap:7px}',
      '.mh-paiement__logo{display:block;width:auto;flex:0 0 auto}',
      '.mh-paiement__logo--paypal{height:15px}',
      '.mh-paiement__logo--klarna{height:13px}'
    ].join('');
    document.head.appendChild(s);
  }

  var balise = document.querySelector('script[data-logo-paypal]');
  var LOGOS = {
    paypal: balise ? balise.getAttribute('data-logo-paypal') : '',
    klarna: balise ? balise.getAttribute('data-logo-klarna') : ''
  };

  function imageLogo(cle, nom) {
    if (!LOGOS[cle]) return '';
    return (
      '<img class="mh-paiement__logo mh-paiement__logo--' + cle + '"' +
      ' src="' + LOGOS[cle] + '" alt="' + nom + '" loading="lazy" decoding="async">'
    );
  }

  function construit(ancre) {
    var bloc = document.createElement('div');
    bloc.className = CLASSE;
    bloc.innerHTML =
      '<span>ou <span class="mh-paiement__montant" data-mh-4x></span> sans frais avec</span>' +
      '<span class="mh-paiement__fin">' +
      imageLogo('paypal', 'PayPal') +
      imageLogo('klarna', 'Klarna') +
      '<span class="mh-paiement__aide" tabindex="0" role="button"' +
      ' aria-label="Détail du paiement en plusieurs fois">?' +
        '<span class="mh-paiement__bulle" role="tooltip">' +
          '<b>Profitez de notre facilité de paiement</b>' +
          '<span class="l">Payez en <strong>4 fois</strong> sans frais avec PayPal :' +
          ' <span data-mh-bulle-4x></span> par mois.</span>' +
          '<span class="l">Payez en <strong>3 fois</strong> sans frais avec Klarna :' +
          ' <span data-mh-bulle-3x></span> par mois.</span>' +
          '<span class="n">Choisissez votre option directement au moment du paiement.</span>' +
        '</span>' +
      '</span>' +
      '</span>';
    ancre.insertAdjacentElement('afterend', bloc);
    return bloc;
  }

  function maj() {
    var elPrix = elementPrix();
    var bloc = document.querySelector('.' + CLASSE);

    var prix = prixCourant(elPrix);

    if (!prix || prix < PAIEMENT_MINI) {
      if (bloc) bloc.remove();
      return;
    }

    styles();

    if (!bloc) {
      var ancre = elPrix.closest('product-price');
      if (!ancre) return;
      bloc = construit(ancre);
    }

    var q4 = formate(Math.round(prix / 4));
    var q3 = formate(Math.round(prix / 3));

    bloc.querySelector('[data-mh-4x]').textContent = '4x ' + q4;
    bloc.querySelector('[data-mh-bulle-4x]').textContent = q4;
    bloc.querySelector('[data-mh-bulle-3x]').textContent = q3;
  }

  function majDifferee() {
    setTimeout(maj, 80);
    setTimeout(maj, 350);
    setTimeout(maj, 900);
  }

  document.addEventListener('variant:updated', majDifferee);
  document.addEventListener('form:updated', majDifferee);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', maj);
  } else {
    maj();
  }
  setTimeout(maj, 400);
})();
